module.exports = __webpack_public_path__ + "img/right_angle_corner_icon.db6dc2b7.svg";